// Who was driving, and the number you reach him on.
//
// A driver's name on its own is not actionable. The reason anybody looks up the driver of a trip is
// to call him - the truck is late, it is at the wrong gate, the challan does not match what came off
// it - and a name alone means going to another screen first. The register already holds the number,
// and a trip already records which driver it was, so the two belong together wherever the name is
// shown.
//
// A trip stores the name as at the time it ran but not the number, so the number is resolved from
// the register by id. That is deliberate: it gives the current number, which is the one that will
// actually ring, and it works for trips recorded before any of this existed. Where the driver has
// since been removed from the register there is no number to show, and the name stands alone rather
// than the row pretending to be complete.

/**
 * The driver's name and number for a record that names a driver.
 *
 * Takes the register and anything carrying a driver: a trip (`driverId`, `driver`), a vehicle
 * (`driverId`, `driverName`, `driverMobile`) or an intake form. A number recorded on the record
 * itself wins, because that is what was taken down at the gate for that particular movement.
 */
export const driverContact = (drivers, record) => {
  if (!record) return { name: '', mobile: '' };
  const name = record.driver || record.driverName || '';
  const held = record.driverMobile || '';
  if (held) return { name, mobile: held };
  const known = (drivers || []).find((who) => who.id === record.driverId);
  return { name: name || known?.name || '', mobile: known?.mobile || known?.reference || '' };
};

/**
 * The same thing as one line, in the form the vehicle register has always used.
 *
 * Returns an empty string when there is neither, so a caller can fall back to its own dash rather
 * than printing a stray separator.
 */
export const driverLabel = (drivers, record) => {
  const { name, mobile } = driverContact(drivers, record);
  return [name, mobile].filter(Boolean).join(' · ');
};
